module.exports = __webpack_public_path__ + "img/0011.ae50cbb8.jpg";